/* eslint-disable react/no-deprecated */
import { Component } from 'react';
import BaseChart from 'legacy/javascripts/components/base_chart.es6';
import { DateTime } from 'common/utils/date';

class StarDistributionClass extends Component {
  render() {
    let options = {
      tooltips: {
        mode: 'nearest',
        footerMarginTop: 10,
        callbacks: {
          title: (tooltipItems, data) => {
            return `Week of ${DateTime.fromISO(tooltipItems[0].xLabel)
              .toLocaleString(DateTime.DATE_SHORT)}`;
          },
          label: function (tooltipItems, data) {
            let stars =
              parseInt(data.datasets[tooltipItems.datasetIndex].label) > 1
                ? 'stars'
                : 'star';
            return `${
              data.datasets[tooltipItems.datasetIndex].label
            } ${stars}: ${tooltipItems.yLabel}%`;
          },
          labelColor: function (tooltipItem, chartInstance) {
            let datasetIndex = tooltipItem.datasetIndex;
            let color =
              chartInstance.data.datasets[datasetIndex].pointBackgroundColor;
            return { borderColor: 'transparent', backgroundColor: color };
          },
        },
      },
      scales: {
        xAxes: [{ display: false, stacked: true }],
        yAxes: [
          {
            display: false,
            stacked: true,
            ticks: { max: 101 },
            gridLines: {
              display: true,
            },
          },
        ],
      },
    };

    return (
      <BaseChart
        id="starDistributionOverTime"
        type="line"
        labels={this.props.data.labels}
        datasets={this.props.data.datasets}
        options={options}
        labelParam="created_at"
        chartHandler={this.props.chartHandler}
      />
    );
  }
}

export default StarDistributionClass;
/* eslint-enable react/no-deprecated */
